import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FileService {
  private http = inject(HttpClient);

  saveFile(number: string, providerCodeId: number, note: string, profile: string, identity: string) {
    return this.http.post<any>(environment.apiUrl + 'save-file', {
      number: number,
      providerCodeId: providerCodeId,
      note: note,
      profile: profile,
      identity: identity,
    });
  }
}
